export default __webpack_public_path__ + "static/guide-7ae0ebb675353c1c2ffe52856ca88b53.webp";